import Loading from './Loading'
import Toast from './Toast'
import Notify from './Notify'
import {
  AlertPlugin,
  ConfirmPlugin,
  PromptPlugin,
  LoadingPlugin,
  ToastPlugin,
  NotifyPlugin,
} from './plugins'

export {
  Loading,
  Toast,
  Notify,
  AlertPlugin,
  ConfirmPlugin,
  PromptPlugin,
  LoadingPlugin,
  ToastPlugin,
  NotifyPlugin,
}

export default {
  Loading,
  Toast,
  Notify,
  AlertPlugin,
  ConfirmPlugin,
  PromptPlugin,
  LoadingPlugin,
  ToastPlugin,
  NotifyPlugin,
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Dialog/index.js